<template lang="pug">
  include ../mixins
  div.position--relative
    component(
      :is-bound="isBound",
      :is='labelComponent',
      :id='id',
      :img="img"
      :value='value',
      :labelText='labelText',
      :input-label='inputLabel',
      :is-required='required'
      :label-class="labelClass"
      v-if="!withoutLabel"
    )
    row(align="center" space="none")
      cell(cols="auto")
        component(
          :is="element",
          :value.prop='value',
          :checked.prop='value'
          ref='input'
          :autocomplete="autocomplete"
          v-on="listeners"
          v-bind='$attrs'
          :type='type'
          v-model='model',
          :class="className"
          :id="id"
          @focus="isBound = true"
          @blur="isBound = false"
        )
        +b.inner-control.A(
          href='',
          v-if='type == "password" '
          @click.prevent='changeType()',
          :class='show ? "de-icon de-icon--type_eye-on text--size_2sm display_block" : "de-icon de-icon--type_eye-off text--size_2sm display_block"'
        )
        +b.inner-control--centered(
          v-if='type == "search" '
          class="de-icon--type_search text--size_2xs display_block"
        )
        +b.inner-control--close(
          v-if='type == "search" && value && value.length > 0'
          class="de-icon--type_close text--size_2xs display_block"
          @click="$emit('clear')"
        )
      +b.inner-control--icon.COMPONENT(
        v-if="actionType && actionType.length"
        :is='actionComponent'
        :type="actionType"
        @action="$emit('action', $event)"
      )
</template>

<script>
export default {
  name: 'element-input',
  props: [
    'labelComponent',
    'actionComponent',
    'id',
    'img',
    'value',
    'labelText',
    'inputLabel',
    'required',
    'providerContext',
    'type',
    'element',
    'className',
    'labelClass',
    'withoutLabel',
    'actionType',
    'autocomplete',
  ],
  watch: {
    value: {
      handler() {
        this.input = this.value
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      input: '',
      show: false,
      isBound: false,
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: $event => {
          this.$emit('input', this.getEvent($event))
        },
      }
    },
    model: {
      get() {
        return this.input
      },
      set(e) {
        this.input = e
      },
    },
  },
  mounted() {
    this.input = this.value
  },
  methods: {
    getKey() {
      return 'checkbox' === this.type ? 'checked' : 'value'
    },
    changeType() {
      this.show = !this.show
      if (this.show) {
        this.$refs.input.type = 'text'
      } else {
        this.$refs.input.type = this.type
      }
    },
    getEvent(event) {
      if (event && event.type) {
        return event.target[this.getKey()]
      }
      return event
    },
  },
}
</script>
